import React from 'react';
//mui
import { Grid } from '@mui/material';
//widgets
import { AppWidgetStats } from './widgets';
//i18n
import i18n from 'i18';

const StatsSection = ({ statsData }) => (
    <Grid item xs={12} sm={12} md={12}>
        <AppWidgetStats
            displayedStats={statsData}
            title={i18n.t('dashboard.summary')}
            sx={{ mb: 3 }}
        />
    </Grid>
);

export default StatsSection;
